/** Mirrors `OKIS.Domain.Shared.Sanctions.ClsfSanctionCreateSurface` (flags). */
export enum ClsfSanctionCreateSurface {
	None = 0,
	InspectionStep = 1,
	SanctionList = 2,
}

/** The individual surface flags a `[Flags]` bitmask may combine, in stable UI order. */
export const clsfSanctionCreateSurfaceFlags: ClsfSanctionCreateSurface[] = [
	ClsfSanctionCreateSurface.InspectionStep,
	ClsfSanctionCreateSurface.SanctionList,
];

/** Splits a `[Flags]` bitmask into the individual surface flags it contains. */
export function clsfSanctionCreateSurfaceFlagsToArray(value: number): ClsfSanctionCreateSurface[] {
	return clsfSanctionCreateSurfaceFlags.filter((flag) => (value & flag) === flag);
}

/** Combines individual surface flags back into a single `[Flags]` bitmask. */
export function clsfSanctionCreateSurfaceArrayToFlags(values: number[]): number {
	return values.reduce((accumulator, flag) => accumulator | flag, ClsfSanctionCreateSurface.None);
}
